import { SxProps, Theme } from '@mui/material/styles';
import * as React from 'react';

import { toSxArray } from '_lib/utils/helpers';

import { Box } from '../Box/Box';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number | string;
  currentIndex: number | string;
  alwaysDisplay?: boolean; // Use this for a trick that lets us show/hide tabs without re-render
  sx?: SxProps<Theme>;
}

export function TabPanel(props: TabPanelProps) {
  const { children, currentIndex, index, alwaysDisplay, sx } = props;

  return (
    <Box
      sx={[
        {
          height: '100%',
          width: '100%',
          position: 'relative',
          display: currentIndex !== index && !alwaysDisplay ? 'none' : 'flex'
        },
        ...toSxArray(sx)
      ]}
      role='tabpanel'
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}>
      {children}
    </Box>
  );
}
